var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","color":"primary"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"small":"","color":"success","outline":""}},on),[_vm._v("\n      "+_vm._s(_vm.$t("screener.ended.title"))+"\n    ")])]}}])},[_c('span',{staticClass:"background--text body-1"},[_vm._v(_vm._s(_vm.$t("screener.ended.tooltip")))])])}
var staticRenderFns = []

export { render, staticRenderFns }